import React, { useState } from 'react';
import { supabase } from '../services/supabase';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [sending, setSending] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    
    try {
      // Save to Supabase database
      const { error: dbError } = await supabase
        .from('contact_us')
        .insert([{
          name: formData.name,
          email: formData.email,
          subject: formData.subject,
          message: formData.message
        }]);
      
      if (dbError) throw dbError;
      
      /*  Send email notification (will use later)
      const response = await fetch('/api/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          to: 'iwantcheats.store@gmail.com',
          type: 'contact_form',
          name: formData.name,
          email: formData.email,
          subject: formData.subject,
          message: formData.message
        })
      });
      
      if (!response.ok) throw new Error('Failed to send message');
      */
      
      setSubmitted(true);
    } catch (error) {
      alert('Failed to send message. Please try again.');
    } finally {
      setSending(false);
    }
  };

  if (submitted) {
    return (
      <div className="static-page contact-page">
        <h1>Thank You!</h1>
        <p>We've received your message and will respond within 24 hours.</p>
      </div>
    );
  }

  return (
    <div className="static-page contact-page">
      <h1>Contact Us</h1>
      <p>Questions, order issues, or support needs? Send us a message and our team will get back to you quickly.</p>

      <div className="contact-info">
        <div className="contact-method">
          <img src="/assets/icons/mail2.svg" alt="Email" className="contact-icon" />
          <h3>Email</h3>
          <p>iwantcheats.store@gmail.com</p>
        </div>
        <div className="contact-method">
          <img src="/assets/icons/clock.svg" alt="Support Hours" className="contact-icon" />
          <h3>Hours</h3>
          <p>24/7 Support Available</p>
        </div>
        <div className="contact-method">
          <img src="/assets/icons/support-person.svg" alt="Response Time" className="contact-icon" />
          <h3>Response Time</h3>
          <p>Within 24 hours</p>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="contact-form">
        <input
          type="text"
          placeholder="Your Name"
          value={formData.name}
          onChange={(e) => setFormData({...formData, name: e.target.value})}
          required
        />
        <input
          type="email"
          placeholder="Your Email"
          value={formData.email}
          onChange={(e) => setFormData({...formData, email: e.target.value})}
          required
        />
        <input
          type="text"
          placeholder="Subject"
          value={formData.subject}
          onChange={(e) => setFormData({...formData, subject: e.target.value})}
          required
        />
        <textarea
          placeholder="Your Message"
          value={formData.message}
          onChange={(e) => setFormData({...formData, message: e.target.value})}
          rows="6"
          required
        />
        <button type="submit" disabled={sending} className="submit-btn">
          {sending ? 'Sending...' : 'Send Message'}
        </button>
      </form>
    </div>
  );
};

export default ContactPage;
